export default __webpack_public_path__ + "static/media/iphone12.26365a14.png";